import Login from "../Pages/Account/Login";
import AdLandingDoctorEdit from "../Pages/AdLandingForms/AdLandingDoctorEdit";
import AdLandingForms from "../Pages/AdLandingForms/AdLandingForms";
import AddCTA from "../Pages/CTA/AddCTA";
import CTA from "../Pages/CTA/CTA";
import Careers from "../Pages/Careers/Careers";
import JobPost from "../Pages/Careers/JobPost/JobPost";
import JobPostForm from "../Pages/Careers/JobPostForm/JobPostForm";
import Position from "../Pages/Careers/Position/Position";
import PositionForm from "../Pages/Careers/PositionForm/PositionForm";
import Department from "../Pages/Careers/department/Department";
import DepartmentForm from "../Pages/Careers/departmentForm/DepartmentForm";
import AddNewClinic from "../Pages/ClinicHospital/AddNewClinic";
import DoctorInclinicAppointment from "../Pages/ClinicHospital/DoctorInclinicAppointment/DoctorInclinicAppointment";
import AddDoctorInclinicform from "../Pages/ClinicHospital/DoctorInclinicAppointment/form/AddDoctorInclinicform";
import EditDoctorInclinicform from "../Pages/ClinicHospital/DoctorInclinicAppointment/form/EditDoctorInclinicform";
import ViewDoctorInclinicForm from "../Pages/ClinicHospital/DoctorInclinicAppointment/form/ViewDoctorInclinicForm";
import AddNewClinicForm from "../Pages/ClinicHospital/form/AddNewClinicForm";
import EditNewClinicForm from "../Pages/ClinicHospital/form/EditNewClinicForm";
import ViewNewClinicForm from "../Pages/ClinicHospital/form/ViewNewClinicForm";
import DoctorInclinicRedirectOrder from "../Pages/ClinicHospital/pages/DoctorInclinicRedirectOrder";
import DoctorInclinicTrack from "../Pages/ClinicHospital/pages/DoctorInclinicTrack";
import DoctorInclinicTrackEdit from "../Pages/ClinicHospital/pages/DoctorInclinicTrackEdit";
import DoctorInclinicTrackView from "../Pages/ClinicHospital/pages/DoctorInclinicTrackView";
import ContactUs from "../Pages/ContactUs";
import AdUserCounter from "../Pages/Counter/AdUserCounter";
import HomeCounter from "../Pages/Counter/HomeCounter";
import SustainabilityPolicyCounter from "../Pages/Counter/SustainabilityPolicyCounter";
import CTAForm from "../Pages/CtaForm/CTAForm";
import Dashboard from "../Pages/Dashboard/Dashboard";
import DeliveryAppTrainingCentreForm from "../Pages/DeliveryAppTrainingCentre/DeliveryAppTrainingCentreForm";
import ProtectedAddRoute from "../Pages/DeliveryAppTrainingCentre/ProtectedAddRoute";
import DeliveryAppTrainingCentre from "../Pages/DeliveryAppTrainingCentre/index";
import DoctorListingForm from "../Pages/DoctorDetails/DoctorListingForm";
import DoctorInstaDoc from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/DoctorInstaDoc";
import DoctorInstaDocEdit from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/form/DoctorInstaDocEdit";
import DoctorInstaDocView from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/form/DoctorInstaDocView";
import DoctorsInstaDocForm from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/form/DoctorsInstaDocForm";
import InstaDocTrack from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/pages/InstaDocTrack";
import InstaDocTrackRedirect from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/pages/InstaDocTrackRedirect";
import InstaDocTrackView from "../Pages/Doctors/AddNewDoctor/DoctorsInstaDoc/pages/InstaDocTrackView";
import SpecializationMetaForm from "../Pages/Doctors/AddNewDoctor/Forms/SpecializationMetaForm";
import InclinicDoctorSpecialization from "../Pages/Doctors/AddNewDoctor/InClinicDoctorSpecialization/InclinicDoctorSpecialization";
import InclinicDoctorSpecializationForm from "../Pages/Doctors/AddNewDoctor/InClinicDoctorSpecialization/forms/InclinicDoctorSpecializationForm";
import InclinicHealthConcernForm from "../Pages/Doctors/AddNewDoctor/InClinicDoctorSpecialization/forms/InclinicHealthConcernForm";
import InclinicViewHealthConcern from "../Pages/Doctors/AddNewDoctor/InClinicDoctorSpecialization/forms/InclinicViewHealthConcern";
import DoctorActivate from "../Pages/Doctors/AddNewDoctor/Pages/DoctorActivate";
import DoctorTrack from "../Pages/Doctors/AddNewDoctor/Pages/DoctorTrack";
import DoctorTrackRedirect from "../Pages/Doctors/AddNewDoctor/Pages/DoctorTrackRedirect";
import DoctorTrackView from "../Pages/Doctors/AddNewDoctor/Pages/DoctorTrackView";
import DoctorSpecializationMeta from "../Pages/Doctors/AddNewDoctor/specializationMeta";
import AddClinicService from "../Pages/Doctors/ClincService/AddClinicService";
import ClinicService from "../Pages/Doctors/ClincService/ClinicService";
import AddClinicProfile from "../Pages/Doctors/ClinicProfile/AddClinicProfile";
import ClinicMetaTags from "../Pages/Doctors/ClinicProfile/ClinicMetaTags";
import DoctorsClinicProfile from "../Pages/Doctors/ClinicProfile/DoctorsClinicProfile";
import DoctorsFaq from "../Pages/Doctors/ClinicProfile/DoctorsFaq";
import EditDoctorFaq from "../Pages/Doctors/ClinicProfile/EditDoctorFaq";
import EditMetaTags from "../Pages/Doctors/ClinicProfile/EditMetaTags";
import DoctorClinicSpeciality from "../Pages/Doctors/CommonHeidge/ClinicSpeciality/DoctorClinicSpeciality";
import DoctorClinicSpecialityForm from "../Pages/Doctors/CommonHeidge/ClinicSpeciality/Form/DoctorClinicSpecialityForm";
import DoctorExperience from "../Pages/Doctors/CommonHeidge/DoctorsExperience";
import DoctorsGender from "../Pages/Doctors/CommonHeidge/DoctorsGender";
import DoctorsLanguage from "../Pages/Doctors/CommonHeidge/DoctorsLanguage";
import DoctorMedicalCouncil from "../Pages/Doctors/CommonHeidge/DoctorsMedicalCouncil";
import DoctorExperienceForm from "../Pages/Doctors/CommonHeidge/Experience/DoctorExperienceForm";
import DoctorMedicalCouncilForm from "../Pages/Doctors/CommonHeidge/Experience/DoctorMedicalCouncilForm";
import DoctorGenderForm from "../Pages/Doctors/CommonHeidge/Gender/DoctorGenderForm";
import InclinicSpecialization from "../Pages/Doctors/CommonHeidge/InclinicSpecialization";
import InclinicSpecializationForm from "../Pages/Doctors/CommonHeidge/InclinicSpecialization/InclinicSpecializationForm";
import DoctorLanguageForm from "../Pages/Doctors/CommonHeidge/Language/DoctorLanguageForm";
import OnlineSpecializationForm from "../Pages/Doctors/CommonHeidge/OnlineSpecialization/OnlineSpecializationForm";
import OnlineSpecialization from "../Pages/Doctors/CommonHeidge/OnlineSpecicalization";
import OnlineDoctorSpecialisation from "../Pages/Doctors/OnlineDoctorSpecialisation/OnlineDoctorSpecialisation";
import OnlineDoctorSplecialisationForm from "../Pages/Doctors/OnlineDoctorSpecialisation/form/OnlineDoctorSplecialisationForm";
import OnlineHealthConcernForm from "../Pages/Doctors/OnlineDoctorSpecialisation/form/OnlineHealthConcernForm";
import OnlineViewHealthConcern from "../Pages/Doctors/OnlineDoctorSpecialisation/form/OnlineViewHealthConcern";
import PartneredDoctorBoth from "../Pages/Doctors/PartneredDcotor/PartneredDoctorBoth";
import PartneredDoctorForInClinic from "../Pages/Doctors/PartneredDcotor/PartneredDoctorForInClinic";
import PartneredDoctor from "../Pages/Doctors/PartneredDcotor/PartneredDoctorOnline";
import PartneredDoctorForm from "../Pages/Doctors/PartneredDcotor/form/PartneredDoctorForm";
import PartneredDoctorOnline from "../Pages/Doctors/PartneredDcotor/form/PartneredDoctorOnline";
import DoctorsReportError from "../Pages/Doctors/ReportError/Doctor/DoctorsReportError";
import AddDownloadLink from "../Pages/DownloadLink/AddDownloadLink";
import AddLegalDraftedBy from "../Pages/DownloadLink/AddLegalDraftedBy";
import AddMasterLegalPageType from "../Pages/DownloadLink/AddMasterLegalPageType";
import AddMasterLegalPlatformForm from "../Pages/DownloadLink/AddMasterLegalPlatformForm";
import DownloadLink from "../Pages/DownloadLink/DownloadLink";
import MasterLegalDraftedBy from "../Pages/DownloadLink/MasterLegalDraftedBy";
import MasterLegalPageType from "../Pages/DownloadLink/MasterLegalPageType";
import MasterLegalPlatform from "../Pages/DownloadLink/MasterLegalPlatform";
import DoctorBrochures from "../Pages/EmailBrochures/DoctorBrochures";
import DoctorDemoBrochures from "../Pages/EmailBrochures/DoctorDemoBrochures";
import HealthcareBrochures from "../Pages/EmailBrochures/HealthcareBrochures";
import OtherBrochures from "../Pages/EmailBrochures/OtherBrochures";
import PharmacyBrochures from "../Pages/EmailBrochures/PharmacyBrochures";
import FaqBanner from "../Pages/Faq/FaqBanner";
import FaqSectionsQuestionsAndAnswer from "../Pages/Faq/FaqSectionsQuestionAndAnswers";
import NewFaqSection from "../Pages/Faq/NewFaqSection";
import CreateFaqQuestionAndAnswer from "../Pages/Faq/createFaqQuestionAndAnswers";
import EditFaqQuestionAndAnswer from "../Pages/Faq/editFaqQuestionAndAnswers";
// import FranchiseProgramme from "../Pages/HealthsyPharmacy/FranchiseProgramme/franchiseProgramme";
import AddFrpCity from "../Pages/FrpStates/addFrpCity";
import AddNewState from "../Pages/FrpStates/addNewState";
import FrpCities from "../Pages/FrpStates/frpCities";
import FrpStates from "../Pages/FrpStates/frpStates";
import AddNewHealthsyStories from "../Pages/HealthArticle/AddNew/AddNewHealthsyStories";
import BlogBannerImage from "../Pages/HealthArticle/AddNew/BlogBannerImage";
import HealthArticleBlogSearch from "../Pages/HealthArticle/AddNew/HealthArticleBlogSearch";
import HealthArticleBlogSearchForm from "../Pages/HealthArticle/AddNew/HealthArticleBlogSearchForm";
import HealthArticleEdit from "../Pages/HealthArticle/AddNew/HealthArticleEdit";
import HealthsyStories from "../Pages/HealthArticle/AddNew/HealthsyStories";
import Category from "../Pages/HealthArticle/Category/Category";
import CategoryForm from "../Pages/HealthArticle/Category/CategoryForm";
import HealthArticle from "../Pages/HealthArticle/HealthArticle";
import Menu from "../Pages/HealthArticle/menu/Menu";
import MenuForm from "../Pages/HealthArticle/menu/MenuForm";
import DoctorDemo from "../Pages/HealthSynergy/DoctorDemo";
import DoctorRegistration from "../Pages/HealthSynergy/DoctorRegistration";
import DoctorRegistrationEdit from "../Pages/HealthSynergy/DoctorRegistrationEdit";
import HealthcareRegistration from "../Pages/HealthSynergy/HealthcareRegistration";
import HealthcareRegistrationEdit from "../Pages/HealthSynergy/HealthcareRegistrationEdit";
import InstaDocRegistrationEdit from "../Pages/HealthSynergy/InstaDocRegistrationEdit";
import OtherRegistration from "../Pages/HealthSynergy/OtherRegistration";
import { default as PharmacyRegistration } from "../Pages/HealthSynergy/PharmacyRegistration";
import PharmacyRegistrationEdit from "../Pages/HealthSynergy/PharmacyRegistrationEdit ";
import InstaDocRegistration from "../Pages/HealthSynergy/instaDocRegistration";
import AddNewServiceProvider from "../Pages/HomeHealthcare/AddNewServiceProvider/AddNewServiceProvider.";
import AddNewServiceProviderForm from "../Pages/HomeHealthcare/AddNewServiceProvider/form/AddNewServiceProviderForm";
import ViewNewServicdProvider from "../Pages/HomeHealthcare/AddNewServiceProvider/form/ViewNewServicdProvider";
import HealthcareActivate from "../Pages/HomeHealthcare/AddNewServiceProvider/pages/HealthcareActivate";
import HealthcareTrack from "../Pages/HomeHealthcare/AddNewServiceProvider/pages/HealthcareTrack";
import HealthcareTrackRedirect from "../Pages/HomeHealthcare/AddNewServiceProvider/pages/HealthcareTrackRedirect";
import HealthcareTrackView from "../Pages/HomeHealthcare/AddNewServiceProvider/pages/HealthcareTrackView";
import HHSPSpecialisation from "../Pages/HomeHealthcare/HHSPSpecialisation/HHSPSpecialisation";
import AddHsspSpecialisation from "../Pages/HomeHealthcare/HHSPSpecialisation/form/AddHsspSpecialisation";
import EditHsspSpecialisation from "../Pages/HomeHealthcare/HHSPSpecialisation/form/EditHsspSpecialisation";
import ViewHsspSpecialisation from "../Pages/HomeHealthcare/HHSPSpecialisation/form/ViewHsspSpecialisation";
import HHSPSpecialisationActive from "../Pages/HomeHealthcare/HHSPSpecialisation/pages/HHSPSpecialisationActive";
import AddEditInsider from "../Pages/Insiders/AddEditInsider";
import Insiders from "../Pages/Insiders/Insiders";
import InstaDocQrCore from "../Pages/InstaDocQrCore/InstaDocQrCore";
import BD from "../Pages/Masters/Common/BD/BD";
import BDForm from "../Pages/Masters/Common/BD/Form/BDForm";
import Days from "../Pages/Masters/Common/Days/Days";
import DaysForm from "../Pages/Masters/Common/Days/Form/DaysForm";
import Experience from "../Pages/Masters/Common/Experience/Experience";
import ExperienceForm from "../Pages/Masters/Common/Experience/Form/ExperienceForm";
import GenderForm from "../Pages/Masters/Common/Gender/Form/GenderForm";
import Gender from "../Pages/Masters/Common/Gender/Gender";
import LanguagesForm from "../Pages/Masters/Common/Languages/Form/LanguagesForm";
import Lanuages from "../Pages/Masters/Common/Languages/Lanuages";
import LeadStatusForm from "../Pages/Masters/Common/LeadStatus/Form/LeadStatusForm";
import LeadStatus from "../Pages/Masters/Common/LeadStatus/LeadStatus";
import LocationForm from "../Pages/Masters/Common/Location/Form/LocationForm";
import Location from "../Pages/Masters/Common/Location/Location";
import TimingForm from "../Pages/Masters/Common/Timing/Form/TimingForm";
import Timings from "../Pages/Masters/Common/Timing/Timings";
import InClinicForm from "../Pages/Masters/Doctors/InClinicFee/Form/InClinicForm";
import InClinicFee from "../Pages/Masters/Doctors/InClinicFee/InClinicFee";
import PGDegreeForm from "../Pages/Masters/Doctors/PGDegree/Form/PGDegreeForm";
import PGDegree from "../Pages/Masters/Doctors/PGDegree/PGDegree";
import SpecialisationForm from "../Pages/Masters/Doctors/PrimarySpecialisation/Form/SpecialisationForm";
import PrimarySpecialisation from "../Pages/Masters/Doctors/PrimarySpecialisation/PrimarySpecialisation";
import UGDegreeForm from "../Pages/Masters/Doctors/UGCourse/Form/UGDegreeForm";
import UGDegree from "../Pages/Masters/Doctors/UGCourse/UGDegree";
import HealthcareForm from "../Pages/Masters/HomeHealthCare/Form/HealthcareForm";
import HomeHealthCare from "../Pages/Masters/HomeHealthCare/HomeHealthCare";
import OthersForm from "../Pages/Masters/Others/Form/OthersForm";
import Others from "../Pages/Masters/Others/Others";
import InventoryForm from "../Pages/Masters/PartneredPharmacies/Inventory/Form/InventoryForm";
import Inventory from "../Pages/Masters/PartneredPharmacies/Inventory/Inventory";
import PharmacyBusinessForm from "../Pages/Masters/PartneredPharmacies/PharmacyBusiness/Form/PharmacyBusinessForm";
import PharmacyBusiness from "../Pages/Masters/PartneredPharmacies/PharmacyBusiness/PharmacyBusiness";
import PharmacyStoreForm from "../Pages/Masters/PartneredPharmacies/PharmacyStore/Form/PharmacyStoreForm";
import PharmacyStore from "../Pages/Masters/PartneredPharmacies/PharmacyStore/PharmacyStore";
import AdLAndingMetaTags from "../Pages/MetaTags/AdLAndingMetaTags";
import DoctorCityList from "../Pages/OnlineConsultationDoctor/DoctorsCity/DoctorCityList";
import DoctorsCityForm from "../Pages/OnlineConsultationDoctor/DoctorsCity/DoctorsCityForm";
import DoctorslocalitiesList from "../Pages/OnlineConsultationDoctor/DoctorsCity/DoctorslocalitiesList";
import LocalityForm from "../Pages/OnlineConsultationDoctor/DoctorsCity/LocalityForm";
import Comments from "../Pages/PopupData/Comments/Comments";
import ViewComment from "../Pages/PopupData/Comments/ViewComment";
import Subscribe from "../Pages/PopupData/Subscribe/Subscribe";
import AddNewRetailPharmacies from "../Pages/RetailPharmacies/AddNewRetailPharmacies";
import AddNewPharmacyForm from "../Pages/RetailPharmacies/forms/AddNewPharmacyForm";
import EditNewPharmacyForm from "../Pages/RetailPharmacies/forms/EditNewPharmacyForm";
import ViewNewPharmacyForm from "../Pages/RetailPharmacies/forms/ViewNewPharmacyForm";
import RetailPharmacyActive from "../Pages/RetailPharmacies/pages/RetailPharmacyActive";
import RetailPharmacyTrack from "../Pages/RetailPharmacies/pages/RetailPharmacyTrack";
import RetailPharmacyTrackEdit from "../Pages/RetailPharmacies/pages/RetailPharmacyTrackEdit";
import RetailPharmacyTrackRedirect from "../Pages/RetailPharmacies/pages/RetailPharmacyTrackRedirect";
import RetailPharmacyView from "../Pages/RetailPharmacies/pages/RetailPharmacyView";
import PharmaciesPartnerID from "../Pages/RpQrRatings/PharmaciesPartnerID";
import PharmacyPartnerIDForm from "../Pages/RpQrRatings/PharmacyPartnerIDForm";
import PharmacyRatingForm from "../Pages/RpQrRatings/PharmacyRatingForm";
import BannerImages from "../Pages/Settings/BannerImages/BannerImages";
import BusinessSettings from "../Pages/Settings/BusinessSettings/BusinessSettings";
import AddSitemapHeaderForm from "../Pages/Settings/CommonMasters/AddSitemapCategoryForm";
import SitemapNavHeaders from "../Pages/Settings/CommonMasters/SitemapCategory";
import AddCompanyReels from "../Pages/Settings/CompanyReels/AddCompanyReels";
import CompanyReels from "../Pages/Settings/CompanyReels/CompanyReels";
import EmailSettings from "../Pages/Settings/EmailSettings/EmailSettings";
import MetaTags from "../Pages/Settings/MetaTags/MetaTags";
import SiteMapSettings from "../Pages/Settings/SiteMapSettings/SiteMapSettings";
import AddSitemap from "../Pages/Settings/SitemapAnalysis/AddSitemap";
import Sitemap from "../Pages/Settings/SitemapAnalysis/Sitemap";
import SocialForm from "../Pages/Settings/SocialMediaLinks/Form/SocialForm";
import SocialMediaLink from "../Pages/Settings/SocialMediaLinks/SocialMediaLink";
import StoreLinks from "../Pages/Settings/StoreLinks/StoreLinks";
import SustainabilityPolicy from "../Pages/SustainabilityPolicy/SustainabilityPolicy";
import AddNewCity from "../Pages/WebBookings/AddNewCity";
import AddNewHealthCondition from "../Pages/WebBookings/AddNewHealthCondition";
import AddNewServiceCategory from "../Pages/WebBookings/AddNewServiceCategory";
import EditCity from "../Pages/WebBookings/EditCity";
import EditHealthCondition from "../Pages/WebBookings/EditHealthCondition";
import EditServiceCategory from "../Pages/WebBookings/EditServiceCategory";
import ViewCities from "../Pages/WebBookings/viewCities";
import ViewHealthCondition from "../Pages/WebBookings/viewHealthCondition";
import ViewService from "../Pages/WebBookings/viewService";
import ViewServiceCategory from "../Pages/WebBookings/viewServiceCategory";
import WebBookings from "../Pages/WebBookings/webBookings";
import Page404 from "../components/Common/404";
import { PrimaryButton } from "../components/Common/ButtonComp";
// import HealthsyServiceRoutes from "./healhsyService";
import ManufacturerList from "../Pages/HealthsyServices/Master/ManufacturerList";
import ManufacturerListForm from "../Pages/HealthsyServices/Master/ManufacturerListForm";
import MarketersList from "../Pages/HealthsyServices/Master/MarketersList";
import MarketersListForm from "../Pages/HealthsyServices/Master/MarketersListForm";
import PincodeList from "../Pages/HealthsyServices/Master/Pincode";
import PincodeListForm from "../Pages/HealthsyServices/Master/PincodeListForm";
import ProductType from "../Pages/HealthsyServices/Master/ProductType";
import ProductTypeForm from "../Pages/HealthsyServices/Master/ProductTypeForm";
import SaltMolecules from "../Pages/HealthsyServices/Master/SaltMolecules";
import SaltMoleculesForm from "../Pages/HealthsyServices/Master/SaltMoleculesForm";
import SaltMoleculeMedicines from "../Pages/HealthsyServices/Master/SaltMoleculesMedicines";
import Unit from "../Pages/HealthsyServices/Master/Unit";
import UnitForm from "../Pages/HealthsyServices/Master/UnitForm";
import MedicinesAssets from "../Pages/HealthsyServices/MedicineAssets";
import MedicineAssetsUpload from "../Pages/HealthsyServices/MedicineAssetsUpload";
import MedicineDetails from "../Pages/HealthsyServices/MedicineList/MedicineDetails";
import MedicineDetailsForm from "../Pages/HealthsyServices/MedicineList/MedicineDetailsForm";
import FranchiseCustomerContactUs from "../Pages/HealthsyPharmacy/FranchiseProgramme/ContactUs";
import FranchiseCustomerCareers from "../Pages/HealthsyPharmacy/FranchiseProgramme/Career";
import FranchiseCustomerStoreLocation from "../Pages/HealthsyPharmacy/FranchiseProgramme/storeLocation";
import StoreLocationForm from "../Pages/HealthsyPharmacy/FranchiseProgramme/storeLocationForm";
import InterestSubmittedList from "../Pages/HealthsyPharmacy/FranchiseProgramme/InterestSubmittedList";
import Faqs from "../Pages/HealthsyPharmacy/FranchiseProgramme/FaqMasters";
import CityTownMaster from "../Pages/HealthsyPharmacy/FranchiseProgramme/CityTownMaster";
import CityTownMasterForm from "../Pages/HealthsyPharmacy/FranchiseProgramme/CityTownMasterForm";
import FaqMastersForm from "../Pages/HealthsyPharmacy/FranchiseProgramme/FaqMasterForm";

const token = localStorage.getItem("authToken");

const SessionExpired = () => {
  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      <div className="fs-1 text-primarycolor">
        Something went wrong, Please login again
      </div>
      <div className="mt-4">
        <PrimaryButton
          onClick={() => {
            localStorage.removeItem("authToken");
            window.location.href = "/login";
          }}
          buttonName="Login Again"
        />
      </div>
    </div>
  );
};

const authRoutes = [
  { path: "*", element: <Page404 /> },
  { path: "/login", element: token ? <SessionExpired /> : <Login /> },
];

const dashboardRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/dashboard", element: <Dashboard /> },
];

const healthSynergyRoutes = [
  { path: "/doctor-registration", element: <DoctorRegistration /> },
  { path: "/pharmacy-registration", element: <PharmacyRegistration /> },
  { path: "/healthcare-registration", element: <HealthcareRegistration /> },
  { path: "/insta-doc", element: <InstaDocRegistration /> },
  { path: "/other-registration", element: <OtherRegistration /> },
  { path: "/doctor-demo", element: <DoctorDemo /> },
  {
    path: "/doctor-registration-edit/:id",
    element: <DoctorRegistrationEdit />,
  },
  {
    path: "/healthcare-registration-edit/:id",
    element: <HealthcareRegistrationEdit />,
  },
  {
    path: "/insta-doc-registration-edit/:id",
    element: <InstaDocRegistrationEdit />,
  },
  {
    path: "/pharmacy-registration-edit/:id",
    element: <PharmacyRegistrationEdit />,
  },
];

const masterPrimarySpecialisationRoutes = [
  {
    path: "/master-primary-specialisation",
    element: <PrimarySpecialisation />,
  },
  {
    path: "/master-specialisation-edit/:id",
    element: <SpecialisationForm />,
  },
  {
    path: "/master-specialisation-view/:id",
    element: <SpecialisationForm />,
  },
  {
    path: "/master-specialisation-create",
    element: <SpecialisationForm />,
  },
];

const masterInclinicFeeRoutes = [
  { path: "/master-inclinic-fee", element: <InClinicFee /> },
  { path: "/master-in-clinic-create", element: <InClinicForm /> },
  { path: "/master-inclinic-edit/:id", element: <InClinicForm /> },
  { path: "/master-inclinic-view/:id", element: <InClinicForm /> },
];

const masterUGCourseRoutes = [
  { path: "/master-ug-course", element: <UGDegree /> },
  { path: "/master-ug-course-create", element: <UGDegreeForm /> },
  {
    path: "/master-ug-course-edit/:id",
    element: <UGDegreeForm edit={true} />,
  },
  {
    path: "/master-ug-course-view/:id",
    element: <UGDegreeForm view={true} />,
  },
];

const masterPGDegreeRoutes = [
  { path: "/master-pg-degree", element: <PGDegree /> },
  { path: "/master-pg-degree-create", element: <PGDegreeForm /> },
  {
    path: "/master-pg-degree-edit/:id",
    element: <PGDegreeForm edit={true} />,
  },
  {
    path: "/master-pg-degree-view/:id",
    element: <PGDegreeForm view={true} />,
  },
];

const masterHealthCareRoutes = [
  { path: "/master-health-care", element: <HomeHealthCare /> },
  { path: "/master-health-care-create", element: <HealthcareForm /> },
  {
    path: "/master-health-care-edit/:id",
    element: <HealthcareForm edit={true} />,
  },
  {
    path: "/master-health-care-view/:id",
    element: <HealthcareForm view={true} />,
  },
];

const masterPartneredPharmacyRoutes = [
  { path: "/master-partnered-pharmacy", element: <PharmacyBusiness /> },
  {
    path: "/master-partnered-pharmacy-create",
    element: <PharmacyBusinessForm />,
  },
  {
    path: "/master-partnered-pharmacy-edit/:id",
    element: <PharmacyBusinessForm />,
  },
  {
    path: "/master-partnered-pharmacy-view/:id",
    element: <PharmacyBusinessForm />,
  },
];

const masterInventoryRoutes = [
  { path: "/master-inventory", element: <Inventory /> },
  { path: "/master-inventory-create", element: <InventoryForm /> },
  { path: "/master-inventory-edit/:id", element: <InventoryForm /> },
  { path: "/master-inventory-view/:id", element: <InventoryForm /> },
];

const masterPharmacyStoreRoutes = [
  { path: "/master-pharmacy-store", element: <PharmacyStore /> },
  { path: "/master-pharmacy-store-create", element: <PharmacyStoreForm /> },
  {
    path: "/master-pharmacy-store-edit/:id",
    element: <PharmacyStoreForm />,
  },
  {
    path: "/master-pharmacy-store-view/:id",
    element: <PharmacyStoreForm />,
  },
];

const masterOthersRoutes = [
  { path: "/master-others", element: <Others /> },
  { path: "/master-others-form", element: <OthersForm /> },
  { path: "/master-others-edit/:id", element: <OthersForm edit={true} /> },
  { path: "/master-others-view/:id", element: <OthersForm view={true} /> },
];

const masterGenderRoutes = [
  { path: "/master-gender", element: <Gender /> },
  { path: "/master-gender-create", element: <GenderForm /> },
  { path: "/master-gender-edit/:id", element: <GenderForm /> },
  { path: "/master-gender-view/:id", element: <GenderForm /> },
];

const masterExperienceRoutes = [
  { path: "/master-experience", element: <Experience /> },
  { path: "/master-experience-create", element: <ExperienceForm /> },
  { path: "/master-experience-edit/:id", element: <ExperienceForm /> },
  { path: "/master-experience-view/:id", element: <ExperienceForm /> },
];

const masterLanguagesRoutes = [
  { path: "/master-languages", element: <Lanuages /> },
  { path: "/master-languages-create", element: <LanguagesForm /> },
  { path: "/master-languages-edit/:id", element: <LanguagesForm /> },
  { path: "/master-languages-view/:id", element: <LanguagesForm /> },
];

const masterLocationRoutes = [
  { path: "/master-location", element: <Location /> },
  { path: "/master-location-create", element: <LocationForm /> },
  { path: "/master-location-edit/:id", element: <LocationForm /> },
  { path: "/master-location-view/:id", element: <LocationForm /> },
];

const masterTimingRoutes = [
  { path: "/master-timing", element: <Timings /> },
  { path: "/master-timings-create", element: <TimingForm /> },
  { path: "/master-timing-edit/:id", element: <TimingForm /> },
  { path: "/master-timing-view/:id", element: <TimingForm /> },
];

const masterDaysRoutes = [
  { path: "/master-days", element: <Days /> },
  { path: "/master-days-create", element: <DaysForm /> },
  { path: "/master-days-edit/:id", element: <DaysForm /> },
  { path: "/master-days-view/:id", element: <DaysForm /> },
];

const masterBDRoutes = [
  { path: "/master-bd", element: <BD /> },
  { path: "/master-bd-create", element: <BDForm /> },
  { path: "/master-bd-edit/:id", element: <BDForm /> },
  { path: "/master-bd-view/:id", element: <BDForm /> },
];

const masterLeadStatusRoutes = [
  { path: "/master-lead-status", element: <LeadStatus /> },
  { path: "/master-lead-status-create", element: <LeadStatusForm /> },
  { path: "/master-lead-status-edit/:id", element: <LeadStatusForm /> },
  { path: "/master-lead-status-view/:id", element: <LeadStatusForm /> },
];

const popupDataRoutes = [
  { path: "/comment", element: <Comments /> },
  { path: "/view-comment/:id", element: <ViewComment /> },
  { path: "/blog-subscribe", element: <Subscribe /> },
];

const healthArticleRoutes = [
  { path: "/healtharticle", element: <HealthArticle /> },
  {
    path: "/healtharticleaddnew",
    element: <HealthArticleEdit edit={false} />,
  },
  {
    path: "/healtharticleEdit/:id",
    element: <HealthArticleEdit edit={true} />,
  },
  {
    path: "/healthArticleView/:id",
    element: <HealthArticleEdit view={true} />,
  },
];

const healthArticleMenuRoutes = [
  { path: "/healtharticlemenu", element: <Menu /> },
  { path: "/addNewMenuForm", element: <MenuForm /> },
  { path: "/addNewMenuEditForm/:id", element: <MenuForm edit={true} /> },
  { path: "/viewMenuForm/:id", element: <MenuForm view={true} /> },
];

const healthArticleCategoryRoutes = [
  { path: "/addNewCategoryForm", element: <CategoryForm /> },
  {
    path: "/addNewCategoryEditForm/:id",
    element: <CategoryForm edit={true} />,
  },
  { path: "/viewCategoryForm/:id", element: <CategoryForm view={true} /> },
  { path: "/Category", element: <Category /> },
];

const healthsyStoriesRoutes = [
  { path: "/healthsystories", element: <HealthsyStories /> },
  { path: "/addNewHealthsyStories", element: <AddNewHealthsyStories /> },
  {
    path: "/healthsystories-edit/:id",
    element: <AddNewHealthsyStories edit={true} />,
  },
];

const blogSearchRoutes = [
  { path: "/blog-search-keyword", element: <HealthArticleBlogSearch /> },
  {
    path: "/blog-search-keyword-create",
    element: <HealthArticleBlogSearchForm />,
  },
  {
    path: "/blog-search-keyword-edit/:id",
    element: <HealthArticleBlogSearchForm edit={true} />,
  },
];

const blogBannerRoutes = [
  { path: "/blog-banner-image", element: <BlogBannerImage /> },
];

const careersRoutes = [{ path: "/careers", element: <Careers /> }];

const healthsyServicesRoutes = [
  {
    path: "/healthsy-services/order-medicines/medicine-details",
    element: <MedicineDetails />,
  },
  {
    path: "/healthsy-services/order-medicines/medicine-details-form",
    element: <MedicineDetailsForm />,
  },
  {
    path: "/healthsy-services/order-medicines/edit-medicine/:id",
    element: <MedicineDetailsForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/assets",
    element: <MedicinesAssets edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/upload-assets",
    element: <MedicineAssetsUpload edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/medicine-list",
    element: <MedicineDetails />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/manufacturer",
    element: <ManufacturerList />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/manufacturer-form",
    element: <ManufacturerListForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/manufacturer-form-edit/:id",
    element: <ManufacturerListForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/marketers",
    element: <MarketersList />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/marketers-form",
    element: <MarketersListForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/marketers-form-edit/:id",
    element: <MarketersListForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/salt-molecules",
    element: <SaltMolecules />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/salt-molecules-form",
    element: <SaltMoleculesForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/salt-molecules-form-edit/:id",
    element: <SaltMoleculesForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/unit",
    element: <Unit />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/unit-form",
    element: <UnitForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/product-type",
    element: <ProductType />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/product-type-form",
    element: <ProductTypeForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/product-type-form-edit/:id",
    element: <ProductTypeForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/pincode-list",
    element: <PincodeList />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/pincode-list-form",
    element: <PincodeListForm />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/pincode-list-form-edit/:id",
    element: <PincodeListForm edit={true} />,
  },
  {
    path: "/healthsy-services/order-medicines/masters/:id/view-medicines",
    element: <SaltMoleculeMedicines edit={true} />,
  },
];

const careerJobPostRoutes = [
  { path: "/careerjobpost", element: <JobPost /> },
  { path: "/careerjobpostform", element: <JobPostForm /> },
  { path: "/jobpostedit/:id", element: <JobPostForm edit={true} /> },
];

const careerDepartmentRoutes = [
  { path: "/careerdepartment", element: <Department /> },
  { path: "/departmentFunctionForm", element: <DepartmentForm /> },
  {
    path: "/careerDepartmentEdit/:id",
    element: <DepartmentForm edit={true} />,
  },
];

const careerPositionRoutes = [
  { path: "/careerposition", element: <Position /> },
  { path: "/careerpositionForm", element: <PositionForm /> },
  {
    path: "/careerpositionEdit/:id",
    element: <PositionForm edit={true} />,
  },
];

const partneredDoctorRoutes = [
  {
    path: "/partnered-doctor-form-create",
    element: <PartneredDoctorForm />,
  },
  {
    path: "/partnered-doctor/edit/:id",
    element: <PartneredDoctorForm edit={true} />,
  },
  { path: "/partnered-doctor-online", element: <PartneredDoctor /> },
  {
    path: "/partnered-doctor-inclinic",
    element: <PartneredDoctorForInClinic />,
  },
  { path: "/partnered-doctor-both", element: <PartneredDoctorBoth /> },
];

const doctorListingRoutes = [
  { path: "/add-new-doctors", element: <DoctorSpecializationMeta /> },
  {
    path: "/create-doctor-listing-page-meta-set",
    element: <SpecializationMetaForm />,
  },
  {
    path: "/create-doctor-listing-page-meta-set/:id",
    element: <SpecializationMetaForm edit={true} />,
  },
];

const inclinicSpecializationRoutes = [
  {
    path: "/inclinic-specialization",
    element: <InclinicDoctorSpecialization />,
  },
  {
    path: "/inclinic-specialization-create",
    element: <InclinicDoctorSpecializationForm />,
  },
  {
    path: "/inclinic-specialization-edit/:id",
    element: <InclinicDoctorSpecializationForm edit={true} />,
  },
  {
    path: "/inclinic-view-health-concern/:id",
    element: <InclinicViewHealthConcern />,
  },
  {
    path: "/inclinic-add-health-concern/:inclinic_specialization_id",
    element: <InclinicHealthConcernForm />,
  },
  {
    path: "/inclinic-edit-health-concern/:inclinic_specialization_id/:id",
    element: <InclinicHealthConcernForm edit={true} />,
  },
];

const onlineDoctorSpecialisationRoutes = [
  {
    path: "/online-doctor-specialisation",
    element: <OnlineDoctorSpecialisation />,
  },
  {
    path: "/online-doctor-add-new-splecialisation-form",
    element: <OnlineDoctorSplecialisationForm />,
  },
  {
    path: "/online-doctor-splecialisation-edit/:id",
    element: <OnlineDoctorSplecialisationForm edit={true} />,
  },
  {
    path: "/online-doctor-add-health-concern/:doctor_specialization_id",
    element: <OnlineHealthConcernForm />,
  },
  {
    path: "/online-doctor-health-concern-edit/:doctor_specialization_id/:id",
    element: <OnlineHealthConcernForm edit={true} />,
  },
  {
    path: "/online-doctor-view-health-concern/:id",
    element: <OnlineViewHealthConcern />,
  },
];

const doctorsLocationRoutes = [
  { path: "/doctors-location", element: <DoctorCityList /> },
  {
    path: "/doctors-location-edit/:id",
    element: <DoctorsCityForm edit={true} />,
  },
  { path: "/doctors-location-create", element: <DoctorsCityForm /> },
  { path: "/doctors-localities/:id", element: <DoctorslocalitiesList /> },
  {
    path: "/doctors-localities-list/:id",
    element: <DoctorsCityForm edit={true} localityEdit={true} />,
  },
  { path: "/:city_name/add-locality", element: <LocalityForm /> },
  {
    path: "/:city_name/edit-locality/:id",
    element: <LocalityForm edit={true} />,
  },
];

const doctorClinicProfileRoutes = [
  { path: "/doctor-clinic-profile", element: <DoctorsClinicProfile /> },
  { path: "/doctor-clinic-profile-create", element: <AddClinicProfile /> },
  {
    path: "/clinic-profile-edit/:id",
    element: <AddClinicProfile edit={true} />,
  },
];

const doctorClinicServiceRoutes = [
  { path: "/doctor-clinic-service", element: <ClinicService /> },
  { path: "/doctor-clinic-service-create", element: <AddClinicService /> },
  {
    path: "/doctor-clinic-service-edit/:id",
    element: <AddClinicService edit={true} />,
  },
];

const doctorsGenderRoutes = [
  { path: "/doctors-gender", element: <DoctorsGender /> },
  { path: "/doctor-gender-create", element: <DoctorGenderForm /> },
  {
    path: "/doctor-gender-edit/:id",
    element: <DoctorGenderForm edit={true} />,
  },
  {
    path: "/doctor-gender-view/:id",
    element: <DoctorGenderForm view={true} />,
  },
];

const doctorsExperienceRoutes = [
  { path: "/doctors-experience", element: <DoctorExperience /> },
  { path: "/doctors-experience-create", element: <DoctorExperienceForm /> },
  {
    path: "/doctors-experience-view/:id",
    element: <DoctorExperienceForm view={true} />,
  },
  {
    path: "/doctors-experience-edit/:id",
    element: <DoctorExperienceForm edit={true} />,
  },
];

const doctorsMedicalCouncilRoutes = [
  { path: "/doctors-medical-council", element: <DoctorMedicalCouncil /> },
  {
    path: "/doctors-medical-council-create",
    element: <DoctorMedicalCouncilForm />,
  },
  {
    path: "/doctors-medical-council-view/:id",
    element: <DoctorMedicalCouncilForm view={true} />,
  },
  {
    path: "/doctors-medical-council-edit/:id",
    element: <DoctorMedicalCouncilForm edit={true} />,
  },
];

const doctorsLanguageRoutes = [
  { path: "/doctors-language", element: <DoctorsLanguage /> },
  { path: "/doctors-language-create", element: <DoctorLanguageForm /> },
  {
    path: "/doctors-language-edit/:id",
    element: <DoctorLanguageForm edit={true} />,
  },
  {
    path: "/doctors-language-view/:id",
    element: <DoctorLanguageForm view={true} />,
  },
];

const doctorsClinicSpecialityRoutes = [
  {
    path: "/doctors-clinic-speciality",
    element: <DoctorClinicSpeciality />,
  },
  {
    path: "/doctors-clinic-speciality-create",
    element: <DoctorClinicSpecialityForm />,
  },
  {
    path: "/doctors-clinic-speciality-edit/:id",
    element: <DoctorClinicSpecialityForm edit={true} />,
  },
  {
    path: "/doctors-clinic-speciality-view/:id",
    element: <DoctorClinicSpecialityForm view={true} />,
  },
];

const onlineSpecializationRoutes = [
  { path: "/online-specialization", element: <OnlineSpecialization /> },
  {
    path: "/online-specialization-create",
    element: <OnlineSpecializationForm />,
  },
  {
    path: "/online-specialization-edit/:id",
    element: <OnlineSpecializationForm edit={true} />,
  },
  {
    path: "/online-specialization-view/:id",
    element: <OnlineSpecializationForm view={true} />,
  },
];

const inclinicSpecializationsRoutes = [
  {
    path: "/inclinic-specializations",
    element: <InclinicSpecialization />,
  },
  {
    path: "/inclinic-specializations-create",
    element: <InclinicSpecializationForm />,
  },
  {
    path: "/inclinic-specializations-edit/:id",
    element: <InclinicSpecializationForm edit={true} />,
  },
  {
    path: "/inclinic-specialization-view/:id",
    element: <InclinicSpecializationForm view={true} />,
  },
];

const doctorsReportRoutes = [
  {
    path: "/doctors-report",
    element: <DoctorsReportError type="online-doctor" />,
  },
  {
    path: "/inclinic-doctors-report",
    element: <DoctorsReportError type="inclinic-doctor" />,
  },
  {
    path: "/clinics-report",
    element: <DoctorsReportError type="clinic" />,
  },
];

const homeHealthcareRoutes = [
  {
    path: "/home-healthcare-service-provider",
    element: <AddNewServiceProvider />,
  },
  {
    path: "/home-healthcare-service-provider-form",
    element: <AddNewServiceProviderForm />,
  },
  {
    path: "/home-healthcare-service-provider-edit/:id",
    element: <AddNewServiceProviderForm edit={true} />,
  },
  { path: "/healthcare-view/:id", element: <ViewNewServicdProvider /> },
];

const hhspRoutes = [
  { path: "/home-healthcare-hhsp", element: <HHSPSpecialisation /> },
  {
    path: "/home-healthcare-hhsp-form",
    element: <AddHsspSpecialisation />,
  },
  {
    path: "/home-healthcare-hhsp-edit",
    element: <EditHsspSpecialisation />,
  },
  {
    path: "/home-healthcare-hhsp-view",
    element: <ViewHsspSpecialisation />,
  },
];

const retailPharmaciesRoutes = [
  { path: "/add-new-retail-pharmacy", element: <AddNewRetailPharmacies /> },
  {
    path: "/add-new-retail-pharmacy-form",
    element: <AddNewPharmacyForm />,
  },
  { path: "/edit-retail-pharmacy-form", element: <EditNewPharmacyForm /> },
  { path: "/view-retail-pharmacy-form", element: <ViewNewPharmacyForm /> },
  { path: "/retail-pharmacy-active", element: <RetailPharmacyActive /> },
  { path: "/retail-pharmacy-track", element: <RetailPharmacyTrack /> },
  {
    path: "/retail-pharmacy-track-redirect",
    element: <RetailPharmacyTrackRedirect />,
  },
  { path: "/retail-pharmacy-track-view", element: <RetailPharmacyView /> },
  {
    path: "/retail-pharmacy-track-edit",
    element: <RetailPharmacyTrackEdit />,
  },
];

const clinicHospitalRoutes = [
  { path: "/add-new-clinic", element: <AddNewClinic /> },
  { path: "/add-new-clinic-form", element: <AddNewClinicForm /> },
  { path: "/edit-clinic-form", element: <EditNewClinicForm /> },
  { path: "/view-clinic-form", element: <ViewNewClinicForm /> },
  { path: "/clinic-track", element: <DoctorInclinicTrack /> },
  {
    path: "/doctor-inclinic-appointment",
    element: <DoctorInclinicAppointment />,
  },
  { path: "/add-new-inclinic-form", element: <AddDoctorInclinicform /> },
  { path: "/edit-inclinic-form", element: <EditDoctorInclinicform /> },
  { path: "/view-inclinic-form", element: <ViewDoctorInclinicForm /> },
  {
    path: "/doctor-inclinic-redirect-order",
    element: <DoctorInclinicRedirectOrder />,
  },
  { path: "/doctor-inclinic-view", element: <DoctorInclinicTrackView /> },
];

const settingsRoutes = [
  { path: "/settings-social-media-form", element: <SocialForm /> },
  { path: "/add-banner-images", element: <BannerImages /> },
  { path: "/store-links", element: <StoreLinks /> },
  { path: "/business-settings", element: <BusinessSettings /> },
  { path: "/meta-tags", element: <MetaTags /> },
  { path: "/email-setting", element: <EmailSettings /> },
];

const insidersRoutes = [
  { path: "/insiders", element: <Insiders /> },
  { path: "/insiders/add-insider", element: <AddEditInsider /> },
  {
    path: "/insiders/:id/edit-insider",
    element: <AddEditInsider edit={true} />,
  },
];

const companyReelsRoutes = [
  { path: "/company-reels", element: <CompanyReels /> },
  { path: "/add-company-reels", element: <AddCompanyReels /> },
  {
    path: "/company-reels-edit/:id",
    element: <AddCompanyReels edit={true} />,
  },
];

const socialMediaRoutes = [
  { path: "/settings-social-media-link", element: <SocialMediaLink /> },
];

const sitemapRoutes = [
  {
    path: "/edit-sitemap-form/:category/:id",
    element: <AddSitemap edit={true} />,
  },
  { path: "/sitemap/:category", element: <Sitemap /> },
  { path: "/site-map-setting", element: <SiteMapSettings /> },
  { path: "/add-sitemap-form/:category", element: <AddSitemap /> },
  { path: "/sitemap-category", element: <SitemapNavHeaders /> },
  {
    path: "/edit-sitemap-category-form/:id",
    element: <AddSitemapHeaderForm edit={true} />,
  },
  { path: "/add-sitemap-category-form", element: <AddSitemapHeaderForm /> },
];

const emailBrochuresRoutes = [
  { path: "/doctor-registration-brochures", element: <DoctorBrochures /> },
  {
    path: "/doctor-demo-registration-brochures",
    element: <DoctorDemoBrochures />,
  },
  {
    path: "/pharmacy-registration-brochures",
    element: <PharmacyBrochures />,
  },
  {
    path: "/healthcare-registration-brochures",
    element: <HealthcareBrochures />,
  },
  { path: "/others-registration-brochures", element: <OtherBrochures /> },
];

const faqRoutes = [
  { path: "/faq", element: <FaqBanner /> },
  { path: "/faq/:id", element: <FaqSectionsQuestionsAndAnswer /> },
  { path: "/faq/add-faq-section", element: <NewFaqSection /> },
  { path: "/faq/:id/add-faq", element: <CreateFaqQuestionAndAnswer /> },
  { path: "/faq/:id/edit-faq", element: <EditFaqQuestionAndAnswer /> },
];

const ctaRoutes = [
  { path: "/cta-banner/:id", element: <CTA /> },
  { path: "/cta-banner/:id/add-new-cta-banner", element: <AddCTA /> },
  { path: "/cta-form/:id", element: <CTAForm /> },
];

const contactRoutes = [{ path: "/contact-us", element: <ContactUs /> }];

const downloadLinksRoutes = [
  { path: "/app-download-link/:id", element: <DownloadLink /> },
  {
    path: "/app-download-link/:id/add-new-app-link",
    element: <AddDownloadLink />,
  },
  {
    path: "/app-download-link/:id/edit-download-link",
    element: <AddDownloadLink edit={true} />,
  },
];

const webBookingsRoutes = [
  { path: "/web-bookings/:id", element: <WebBookings /> },
  {
    path: "/web-bookings/:id/edit-service-category/:id",
    element: <EditServiceCategory />,
  },
  {
    path: "/web-bookings/:id/view-service-categories",
    element: <ViewServiceCategory />,
  },
  { path: "/web-bookings/:id/view-services", element: <ViewService /> },
  {
    path: "/web-bookings/:id/add-new-service-category",
    element: <AddNewServiceCategory />,
  },
  {
    path: "/web-bookings/:id/:id/view-health-conditions",
    element: <ViewHealthCondition />,
  },
  {
    path: "/web-bookings/:id/:id/add-new-health-condition",
    element: <AddNewHealthCondition />,
  },
  { path: "/web-bookings/:id/:id/view-cities", element: <ViewCities /> },
  { path: "/web-bookings/:id/:id/add-new-city", element: <AddNewCity /> },
  {
    path: "/web-bookings/:id/:id/:id/edit-health-condition",
    element: <EditHealthCondition />,
  },
  { path: "/web-bookings/:id/:id/:id/edit-city", element: <EditCity /> },
];

const adLandingRoutes = [
  { path: "/ad-landing-forms/:id", element: <AdLandingForms /> },
  { path: "/ad-landing-doctor-edit/:id", element: <AdLandingDoctorEdit /> },
  { path: "/ad-landing-meta-tags", element: <AdLAndingMetaTags /> },
];

const instaDocRoutes = [
  { path: "/insta-doc-qr-code", element: <InstaDocQrCore /> },
];

const counterRoutes = [
  { path: "/counter-home", element: <HomeCounter /> },
  { path: "/ad-user-counter", element: <AdUserCounter /> },
  {
    path: "/sustainability-policy-counter",
    element: <SustainabilityPolicyCounter />,
  },
];

const sustainabilityRoutes = [
  { path: "/sustainability-policy", element: <SustainabilityPolicy /> },
];

const frpRoutes = [
  { path: "/frp-states", element: <FrpStates /> },
  { path: "/frp-states/add-new-state", element: <AddNewState /> },
  {
    path: "/frp-states/edit-state/:stateSlug",
    element: <AddNewState edit={true} />,
  },
  { path: "/frp-states/view-cities/:stateSlug", element: <FrpCities /> },
  { path: "/frp-states/add-city/:stateSlug", element: <AddFrpCity /> },
  {
    path: "/frp-states/:stateSlug/edit-city/:citySlug",
    element: <AddFrpCity edit={true} />,
  },
];

// const franchiseRoutes = [
//   { path: "/franchise-programme", element: <FranchiseProgramme /> },
// ];
const franchiseRoutes = [
  {
    path: "franchise-programme/contact-us",
    element: <FranchiseCustomerContactUs />,
  },
  {
    path: "franchise-programme/interest-submitted-list",
    element: <InterestSubmittedList />,
  },
  {
    path: "franchise-programme/store-locations",
    element: <FranchiseCustomerStoreLocation />,
  },
  {
    path: "franchise-programme/store-locations/form",
    element: <StoreLocationForm />,
  },
  {
    path: "franchise-programme/store-locations/form/:id",
    element: <StoreLocationForm edit={true} />,
  },
  {
    path: "franchise-programme/city-town-masters",
    element: <CityTownMaster />,
  },
  {
    path: "franchise-programme/city-town-masters/form",
    element: <CityTownMasterForm />,
  },
  {
    path: "franchise-programme/city-town-masters/form/:id",
    element: <CityTownMasterForm edit={true} />,
  },

  {
    path: "franchise-programme/faq-masters",
    element: <Faqs />,
  },
  {
    path: "franchise-programme/faq-masters/form",
    element: <FaqMastersForm />,
  },
  {
    path: "franchise-programme/faq-masters/form/:id",
    element: <FaqMastersForm edit={true} />,
  },
];

const franchiseCustomers = [
  {
    path: "pharmacy-customers/pharmacy-cities",
    element: <FranchiseCustomerContactUs />,
  },
  {
    path: "pharmacy-customers/store-location",
    element: <InterestSubmittedList />,
  },
  {
    path: "pharmacy-customers/store-locations",
    element: <FranchiseCustomerStoreLocation />,
  },
  {
    path: "pharmacy-customers/blogs-guides",
    element: <StoreLocationForm />,
  },
  {
    path: "pharmacy-customers/state-city",
    element: <StoreLocationForm edit />,
  },
  {
    path: "pharmacy-customers/store-interior",
    element: <CityTownMaster />,
  },
];

const rpQrRatingsRoutes = [
  {
    path: "/rp-qr-ratings/pharmacies-partner-id",
    element: <PharmaciesPartnerID />,
  },
  {
    path: "/rp-qr-ratings/add-new-pharmacy-partner-id",
    element: <PharmacyPartnerIDForm />,
  },
  {
    path: "/rp-qr-ratings/edit-pharmacy-partner-id/:id",
    element: <PharmacyPartnerIDForm edit={true} />,
  },
  { path: "/rp-qr-ratings/pharmacy-rating", element: <PharmacyRatingForm /> },
];

const deliveryAppTrainingRoutes = [
  {
    path: "/delivery-app-training-centre",
    element: <DeliveryAppTrainingCentre />,
  },
  {
    path: "/delivery-app-training-centre-create",
    element: (
      <ProtectedAddRoute>
        <DeliveryAppTrainingCentreForm />
      </ProtectedAddRoute>
    ),
  },
  {
    path: "/delivery-app-training-centre-edit/:id",
    element: (
      <ProtectedAddRoute>
        <DeliveryAppTrainingCentreForm />
      </ProtectedAddRoute>
    ),
  },
  {
    path: "/delivery-app-training-centre-view/:id",
    element: (
      <ProtectedAddRoute>
        <DeliveryAppTrainingCentreForm />
      </ProtectedAddRoute>
    ),
  },
];

const masterLegalRoutes = [
  { path: "/master-legal-pages", element: <MasterLegalPlatform /> },
  {
    path: "/add-master-legal-pages",
    element: <AddMasterLegalPlatformForm />,
  },
  {
    path: "/edit-master-legal-pages/:id",
    element: <AddMasterLegalPlatformForm edit={true} />,
  },
  { path: "/master-legal-page-type", element: <MasterLegalPageType /> },
  { path: "/add-master-page-type", element: <AddMasterLegalPageType /> },
  {
    path: "/edit-master-page-type/:id",
    element: <AddMasterLegalPageType edit={true} />,
  },
  { path: "/master-legal-drafted-by", element: <MasterLegalDraftedBy /> },
  { path: "/add-legal-drafted-by", element: <AddLegalDraftedBy /> },
  {
    path: "/edit-legal-drafted-by/:id",
    element: <AddLegalDraftedBy edit={true} />,
  },
];

const doctorActivationRoutes = [
  { path: "/doctor-activate", element: <DoctorActivate /> },
  { path: "/doctor-insta-doc", element: <DoctorInstaDoc /> },
  { path: "/doctor-insta-doc-add-form", element: <DoctorsInstaDocForm /> },
  { path: "/doctor-insta-doc-add-edit", element: <DoctorInstaDocEdit /> },
  { path: "/doctor-insta-doc-add-view", element: <DoctorInstaDocView /> },
  { path: "/doctor-track", element: <DoctorTrack /> },
  { path: "/doctor-track-view", element: <DoctorTrackView /> },
  { path: "/doctor-track-redirect", element: <DoctorTrackRedirect /> },
  { path: "/insta-doc-track", element: <InstaDocTrack /> },
  { path: "/insta-doc-track-redirect", element: <InstaDocTrackRedirect /> },
  { path: "/insta-doc-track-view", element: <InstaDocTrackView /> },
  { path: "/healthcare-activate", element: <HealthcareActivate /> },
  { path: "/healthcare-track", element: <HealthcareTrack /> },
  {
    path: "/healthcare-track-redirect",
    element: <HealthcareTrackRedirect />,
  },
  { path: "/healthcare-track-view", element: <HealthcareTrackView /> },
  { path: "/hhsp-activate", element: <HHSPSpecialisationActive /> },
  {
    path: "/doctor-inclinic-track-edit",
    element: <DoctorInclinicTrackEdit />,
  },
  {
    path: "/booking-details/doctor-consultation",
    element: <DoctorListingForm />,
  },
  { path: "/doctor-add-new-faq", element: <DoctorsFaq /> },
  { path: "/doctor-faq/:id/doctor-edit-faq", element: <EditDoctorFaq /> },
  { path: "/clinic-meta-tags-create", element: <ClinicMetaTags /> },
  { path: "/clinic-meta-tags-edit", element: <EditMetaTags /> },
  { path: "/partnered-doctor-online", element: <PartneredDoctorOnline /> },
];

export const allRouteArrays = [
  authRoutes,
  dashboardRoutes,
  healthSynergyRoutes,
  masterPrimarySpecialisationRoutes,
  masterInclinicFeeRoutes,
  masterUGCourseRoutes,
  masterPGDegreeRoutes,
  masterHealthCareRoutes,
  masterPartneredPharmacyRoutes,
  masterInventoryRoutes,
  masterPharmacyStoreRoutes,
  masterOthersRoutes,
  masterGenderRoutes,
  masterExperienceRoutes,
  masterLanguagesRoutes,
  masterLocationRoutes,
  masterTimingRoutes,
  masterDaysRoutes,
  masterBDRoutes,
  masterLeadStatusRoutes,
  popupDataRoutes,
  healthArticleRoutes,
  healthArticleMenuRoutes,
  healthArticleCategoryRoutes,
  healthsyStoriesRoutes,
  blogSearchRoutes,
  blogBannerRoutes,
  careersRoutes,
  careerJobPostRoutes,
  careerDepartmentRoutes,
  careerPositionRoutes,
  partneredDoctorRoutes,
  doctorListingRoutes,
  inclinicSpecializationRoutes,
  onlineDoctorSpecialisationRoutes,
  doctorsLocationRoutes,
  doctorClinicProfileRoutes,
  doctorClinicServiceRoutes,
  doctorsGenderRoutes,
  doctorsExperienceRoutes,
  doctorsMedicalCouncilRoutes,
  doctorsLanguageRoutes,
  doctorsClinicSpecialityRoutes,
  onlineSpecializationRoutes,
  inclinicSpecializationsRoutes,
  doctorsReportRoutes,
  homeHealthcareRoutes,
  hhspRoutes,
  retailPharmaciesRoutes,
  clinicHospitalRoutes,
  settingsRoutes,
  insidersRoutes,
  companyReelsRoutes,
  socialMediaRoutes,
  sitemapRoutes,
  emailBrochuresRoutes,
  faqRoutes,
  ctaRoutes,
  contactRoutes,
  downloadLinksRoutes,
  webBookingsRoutes,
  adLandingRoutes,
  instaDocRoutes,
  counterRoutes,
  sustainabilityRoutes,
  frpRoutes,
  // franchiseRoutes,
  franchiseRoutes,
  franchiseCustomers,
  rpQrRatingsRoutes,
  deliveryAppTrainingRoutes,
  masterLegalRoutes,
  doctorActivationRoutes,
  healthsyServicesRoutes,
];
